import * as _ from 'lodash';
import { getEnvironmentBase } from './environment-base';
import liff from '@line/liff';

export const childEnvironment = {
  isProduction: false,
  firebase: {
    apiKey: 'AIzaSyD6cchlu8BP37ycABAu3WkAFvPsVq7G2bw',
    authDomain: 'nn-platform-stage.firebaseapp.com',
    projectId: 'nn-platform-stage',
    storageBucket: 'nn-platform-stage',
    messagingSenderId: '824830670374',
    appId: '1:824830670374:web:c81637da81fb29c812d8e7',
  },
  aiiiFirebase: {
    apiKey: 'AIzaSyDU1KGqlcJ87gfuUH2aerjfhJglkbUpn1c',
    authDomain: 'aiii-developer.firebaseapp.com',
    databaseURL: 'https://aiii-developer.firebaseio.com',
    projectId: 'aiii-developer',
    storageBucket: 'aiii-developer.appspot.com',
    messagingSenderId: '700749202278',
  },
  liff: {
    liffId: '2001571544-BbpleeMj',
    previousLiffId: '2004607345-RYZxgjjm',
    clientId: '2001571544',
    officialAccountUrl: 'https://line.me/R/ti/p/@663dshuj',
    // Bridge 成功後指定開啟同一個 Stage OA 的一對一聊天室；勿改用 Production OA。
    officialAccountChatUrl: 'https://line.me/R/oaMessage/%40663dshuj',
  },
  cloudrun: {
    api: 'https://nn-api-main-stage-zfnas7pnkq-de.a.run.app', // nn-platform/nn-api-main-stage
    video: 'https://aiii-api-video-5uvz3vc6ga-de.a.run.app',
    apiv2: 'https://api-v2-5uvz3vc6ga-de.a.run.app', //  aiii-developer/api-v2
    aiApi: 'https://food-category-calculate-824830670374.asia-east1.run.app', // aiii-developer/food-category-calculate
    aiiiApi: 'https://aiii-api-5uvz3vc6ga-de.a.run.app', // aiii-developer/aiii-api
  },
};

export const environment = _.extend(childEnvironment, getEnvironmentBase());
